import React from "react";
import { Text } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import { useTheme } from "@bookingcom/bui-react";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import ErrorAlert from "../ErrorAlert/index.js";
const GenericErrorReport = (props) => {
    const { env } = useGlobalContext();
    const i18n = useI18n();
    const theme = useTheme();
    return (React.createElement(ErrorAlert, { title: i18n.trans(t("flights_error_unknown_header")), buttonLabel: i18n.trans(t("flights_search_again_action")), onClick: () => (location.href = "/") },
        React.createElement(Text, { variant: "body_2" }, i18n.trans(t("flights_error_unknown_subheader"))),
        env !== "prod" && !!props.error && (React.createElement(React.Fragment, null,
            React.createElement("pre", { style: { padding: theme.units.spacing_2x, color: theme.colors.color_foreground_alt } }, JSON.stringify(props.error, null, 2)),
            React.createElement(Text, { variant: "small_1" }, "This error block is not visible on prod")))));
};
export default GenericErrorReport;
